import { render, staticRenderFns } from "./CustomSzwtIotStatsList.vue?vue&type=template&id=08cfd36d&scoped=true&"
import script from "./CustomSzwtIotStatsList.vue?vue&type=script&lang=js&"
export * from "./CustomSzwtIotStatsList.vue?vue&type=script&lang=js&"
import style0 from "./CustomSzwtIotStatsList.vue?vue&type=style&index=0&id=08cfd36d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cfd36d",
  null
  
)

export default component.exports